import React from 'react';

export const NotFound = React.lazy(() =>
  import(/* webpackChunkName: "not-found" */ './NotFound'),
);
